/* Conversion signals contain only event type and page path, never form values. */
(function () {
  if (window.thingnessTrack) return;
  function track(name, details) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return false;
    var data = { page_path: location.pathname, flow: (details && details.flow) || 'site' };
    var dispatched = false;
    if (window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { var result = window.Shopify.analytics.publish(name, data); dispatched = true; if (result && result.catch) result.catch(function () {}); } catch (_) {}
    }
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', name, data); dispatched = true; } catch (_) {}
    }
    return dispatched;
  }
  window.thingnessTrack = track;
  var started = new WeakSet();
  document.addEventListener('focusin', function (e) {
    var f = e.target.closest('[data-tn-enquiry], [data-tn-mop-form]');
    if (f && !started.has(f) && track('enquiry_started', {flow:f.hasAttribute('data-tn-mop-form')?'mockup':'custom'})) started.add(f);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    try { var u = new URL(a.href); if (u.hostname === 'wa.me') track('whatsapp_clicked'); } catch (_) {}
  });
  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-tn-enquiry]')) track('enquiry_submitted', {flow:'custom'});
  });
  // Retry only the success state still on this page, never earlier user actions.
  if (document.querySelector('[data-tn-enquiry-success]')) {
    var confirmed = false;
    var attempts = 0;
    var timer;
    function confirm() {
      if (confirmed || !document.querySelector('[data-tn-enquiry-success]')) {
        clearTimeout(timer);
        document.removeEventListener('visitorConsentCollected', confirm);
        return;
      }
      confirmed = track('enquiry_confirmed', {flow:'custom'});
      if (confirmed) {
        clearTimeout(timer);
        document.removeEventListener('visitorConsentCollected', confirm);
      }
    }
    function retry() {
      confirm();
      attempts += 1;
      if (!confirmed && attempts < 20 && document.querySelector('[data-tn-enquiry-success]')) timer = setTimeout(retry, 500);
    }
    document.addEventListener('visitorConsentCollected', confirm);
    retry();
  }
})();
